// Route search for the cycle count screen. Kept apart from the page module:
// validateSearch runs in the entry chunk, so importing it must not pull the
// page (DataList, panels) into the initial bundle.

import { stockCountListColumns } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";
import type { CountStatusFilter } from "./api";

export interface CountsSearch extends ViewSearch {
  status: CountStatusFilter;
  doc?: string | undefined;
}

export const countStatusFilters: CountStatusFilter[] = ["all", "draft", "in_progress", "posted", "cancelled"];

export function validateCountsSearch(raw: Record<string, unknown>): CountsSearch {
  const status = countStatusFilters.includes(raw.status as CountStatusFilter) ? (raw.status as CountStatusFilter) : "all";
  const doc = typeof raw.doc === "string" && raw.doc.length > 0 && raw.doc.length <= 64 ? raw.doc : undefined;
  return { status, doc, ...viewSearch(stockCountListColumns, raw) };
}
